import { Button, Modal, Text } from '@loomhq/lens';
import React from 'react';
import { useSelector } from 'react-redux';

import { V4 } from 'constants/recordingVersions';
import { MY_VIDEOS_PAGE } from 'constants/routes';

import {
  MAX_FPS,
  MAX_HOURS,
  VIDEO_VALIDATION_FILE_UNSUPPORTED,
  VIDEO_VALIDATION_FPS_TOO_HIGH,
  VIDEO_VALIDATION_MAX_DURATION,
  VIDEO_VALIDATION_RESOLUTION_TOO_HIGH,
  VIDEO_VALIDATION_SCAN_ERROR,
  VIDEO_VALIDATION_SUSPICIOUS,
} from '../../../../../shared/constants/videoUploads';

const validationMessages = {
  [VIDEO_VALIDATION_FILE_UNSUPPORTED]:
    'This file is currently unsupported on Loom',
  [VIDEO_VALIDATION_SUSPICIOUS]:
    'Suspicious content found in file. This file will be removed from your library.',
  [VIDEO_VALIDATION_SCAN_ERROR]: 'There was an issue processing your video.',
  [VIDEO_VALIDATION_FPS_TOO_HIGH]: `The Frames Per Second of your video is above the allowed limit: ${MAX_FPS}fps.`,
  [VIDEO_VALIDATION_RESOLUTION_TOO_HIGH]:
    'The resolution of your video is above the allowed limit: (4k)',
  [VIDEO_VALIDATION_MAX_DURATION]: `The video length is longer than the allowed limit: ${MAX_HOURS} hours`,
};

const GENERIC_VALIDATION_MSG = 'The file could not be processed';
const MY_VIDEOS_UPLOAD_URL = `${MY_VIDEOS_PAGE}?upload=1`;

const onPersonalLibClick = () => {
  window.location.href = MY_VIDEOS_PAGE;
};

const onUploadNewClick = () => {
  window.location.href = MY_VIDEOS_UPLOAD_URL;
};

const ProcessErrorModal = () => {
  const videoUploadValid = useSelector(
    state => state.video_player.video?.processing_information?.videoUploadValid
  );

  const videoUploadMessage = useSelector(
    state =>
      state.video_player.video?.processing_information?.videoUploadMessage
  );

  const isVideoUpload = useSelector(
    state =>
      state.video_player.video?.video_properties?.recording_version === V4
  );

  // Only show if explicitly 'false' and NOT null/undefined
  const showModal = isVideoUpload && videoUploadValid === false;

  return (
    <Modal
      isOpen={showModal}
      mainButton={
        <Button
          href={MY_VIDEOS_UPLOAD_URL}
          htmlTag="a"
          variant="primary"
          onClick={onUploadNewClick}
        >
          Upload New FIle
        </Button>
      }
      secondaryButton={
        <Button href={MY_VIDEOS_PAGE} htmlTag="a" onClick={onPersonalLibClick}>
          Go to Personal Library
        </Button>
      }
    >
      <Text fontWeight="medium" size="large">
        {validationMessages[videoUploadMessage] || GENERIC_VALIDATION_MSG}
      </Text>
    </Modal>
  );
};

export default ProcessErrorModal;
